import { Component, ElementRef, OnInit, SimpleChange, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbService } from 'xng-breadcrumb';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { SummaryService } from 'src/app/services/summary.service';
import { ngxCsv } from 'ngx-csv';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-tanque-gauge',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul app-nav-tanques [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Consumo del tanque</h2>
            <p class="text-muted" style="font-size: 14px;">Consulta el estado del tanque.</p>
            <xng-breadcrumb ></xng-breadcrumb>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill">
            <div class="list-group rounded-4 shadow">
              <div class="list-group-item">
                <h5>Condominio</h5>
                <p class="mb-0">{{settlement.name}}</p>
                <p>Edificio: {{building.name}}</p>

                <h5>Tanque</h5>
                <h2>{{tanque.name}}</h2>

                <div class="alert alert-warning shadow-sm rounded-4" *ngIf="lowWarning">
                  <p class="mb-0">El nivel del tanque se encuentra bajo, requiere de una recarga próximamente.</p>
                </div>
                
              </div>
            </div>
            
          </div>
          <div class="ms-2">
            <div class="card rounded-4 shadow">
              <div class="card-body">
                <div class="d-flex">
                  <div>
                    <h5 class="mb-3">Estatus</h5>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="flex-fill">
                    <ngx-charts-gauge
                      [view]="[view[0], view[1]]"
                      [results]="current_read"
                      [legendTitle]="'Product Sale Chart'"
                      [legend]="false"
                      [min]="0"
                      [max]="tanque.capacidad"
                      [smallSegments]="0"
                      [bigSegments]="5"
                      [startAngle]="-120"
                      [showText]="true"
                    >
                    </ngx-charts-gauge>
                  </div>
                  <div class="text-center">
                    <h3 class=""><span [countUp]="curr_read?.value"></span></h3>
                    <p class="mb-2">Nivel de Gas</p>
                    <h3 *ngIf="refuels">{{curr_read?.lts_estimated}} Lts.</h3>
                    <p class="mt-0 mb-3">Litros estimados</p>
                    <h3 *ngIf="refuels">{{curr_read?.created_at | date: 'dd/MM/yy' }}</h3>
                    <p class="mb-0 ">Última lectura</p>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- div class="d-flex">
          <div class="flex-fill">
            <app-filter-advanced [toDate]="toDate" [fromDate]="fromDate" (dateRange)="updateDate($event)"></app-filter-advanced>
          </div>
          <div class="text-end">
            <button class="btn btn-outline-zazz btn-sm shadow-sm" (click)="search()">
              <fa-icon [icon]="icons.faSearch"></fa-icon>
            </button>
          </div>
        </!-->
        <div class="d-flex flex-fill mt-3">
          <div class="flex-fill">
            <div class="list-group rounded-4 shadow">
              <div class="card list-group-item">
                <h5>Historial de consumo</h5>
                <app-index-chart
                  [data]="data"
                  [consumptions]="consumptions"
                  [start_date]="fromDate"
                  [end_date]="toDate"
                  [tanque]="tanque"
                  [summary]="consumption_data"
                ></app-index-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mb-2">
        <div class="card rounded-4 border-0 shadow mb-3" id="anovaLineChart" #anovaLineChart>
          <div class="card-body p-4" *ngIf="anova_asset_readings.length>0">
            <h5>ANOVA {{anova_asset_readings.length}}</h5>
            <app-anova-line-chart-consumptions
              [data]="anova_asset_readings"
              [start_date]="fromDate"
              [end_date]="toDate"
              [tanque]="tanque"
            ></app-anova-line-chart-consumptions>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card rounded-5 border-0 shadow">
          <div class="card-body p-4">
            <div class="row">
              <div class="col-7">
                <h5 class="mt-2">Lecturas</h5>
              </div>
              <div class="col-5 text-end">
                <button type="button" class="btn btn-outline-info btn-sm rounded-5" (click)="reportReadings()">
                  <fa-icon [icon]="icons.faDownload" *ngIf="!creatingReport"></fa-icon>
                  <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="creatingReport"></fa-icon>
                  Reporte
                </button>
              </div>
              <div class="col-md-12">
              <table class="table table-sm table-striped" *ngIf="readings">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Lectura</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let reading of readings">
                      <td>{{reading.id}}</td>
                      <td>{{reading.value}} %</td>
                      <td>{{reading.created_at | date: 'dd/MM/yyyy' }}</td>
                    </tr>
                    <tr *ngIf="readings.length==0" class="text-center">
                      <td colspan="3">No hay lecturas</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card rounded-5 border-0 shadow">
          <div class="card-body p-4">
            <div class="row mt-0">
              <div class="col-7">
                <h5 class="mt-2">Consumos</h5>
              </div>
              <div class="col-5 text-end">
                <button type="button" class="btn btn-outline-info btn-sm rounded-5" (click)="reportConsumptions()">
                  <fa-icon [icon]="icons.faDownload" *ngIf="!creatingReport"></fa-icon>
                  <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="creatingReport"></fa-icon>  
                  Reporte
                </button>
              </div>
              <div class="col-md-12 mt-2">
                <table class="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th>Recibo</th>
                      <th scope="col">Litros</th>
                      <th scope="col" class="text-end">Fecha</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="consumptions">
                    <tr *ngFor="let consumption of consumptions">
                      <th>{{consumption.bill_id}}</th>
                      <th scope="row">{{consumption.liters | number: '1.2-2'}}</th>
                      <td class="text-end">{{consumption.created_at | date: 'dd/MM/yy' }}</td>
                    </tr>
                    <tr *ngIf="consumptions.length==0">
                      <td colspan="2" class="text-center">No existen consumos en el periodo</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card rounded-5 border-0 shadow mt-4">
          <div class="card-body p-4">
            <div class="row">
              <div class="col-7">
                <h5 class="mt-2">Recargas</h5>
              </div>
              <div class="col-5 text-end">
                <button type="button" class="btn btn-outline-info btn-sm rounded-5" (click)="reportRefuels()">
                  <fa-icon [icon]="icons.faDownload" *ngIf="!creatingReport"></fa-icon>
                  <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="creatingReport"></fa-icon>  
                  Reporte
                </button>
              </div>
              <div class="col-md-12">
                <table class="table table-sm table-striped" *ngIf="readings">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Lectura</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let refuel of refuels">
                      <td>{{refuel.folio}}</td>
                      <td>{{refuel.post_charge}} %</td>
                      <td>{{refuel.updated_at | date: 'dd/MM/yy' }}</td>
                    </tr>
                    <tr *ngIf="refuels.length==0" class="text-center">
                      <td colspan="2">No hay lecturas</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card rounded-5 border-0 shadow mt-4" *ngIf="tanque_children.length>0">
          <div class="card-body p-4">
            <div class="row">
              <div class="col-7">
                <h5 class="mt-2">Tanques en arreglo</h5>
              </div>
              <div class="col-5 text-end">
                <button type="button" class="btn btn-outline-info btn-sm rounded-5" (click)="reportChildReadings()">
                  <fa-icon [icon]="icons.faDownload" *ngIf="!creatingReport"></fa-icon>
                  <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="creatingReport"></fa-icon>  
                  Reporte
                </button>
              </div>
              <div class="col-12">
                <table class="table table-stripped table-sm">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Lectura</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let child of tanque_children">
                      <td>{{child.tanque.name}} </td>
                      <td>{{child.readings.value}}</td>
                      <td>{{child.readings.created_at | date: 'dd/MM/yy'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


   
  `,
  styles: [
		`
			.dp-hidden {
				width: 0;
				margin: 0;
				border: none;
				padding: 0;
			}
			.custom-day {
				text-align: center;
				padding: 0.185rem 0.25rem;
				display: inline-block;
				height: 2rem;
				width: 2rem;
			}
			.custom-day.focused {
				background-color: #e6e6e6;
			}
			.custom-day.range,
			.custom-day:hover {
				background-color: rgb(2, 117, 216);
				color: white;
			}
			.custom-day.faded {
				background-color: rgba(2, 117, 216, 0.5);
			}
		`,
	],
})
export class TanqueGaugeComponent implements OnInit {
  @ViewChild('nivel') nivel: ElementRef | undefined;
  currentView: string = 'tanques';

  tanqueId: any = null;
  tanque: any = {};
  consumptions: any = [];
  view = [180, 100];
  units: string = '% Restante';
  deptos: any = [];
  refuels: any = [];
  readings: any = [];

  creatingReport: boolean = false;

  consumption_data: any = [];
  consumption_consumptions: any = [];
  consumption_tanques: any = [];

  anova_asset_readings: any = [];

  current_read: any = null;

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate; // : any = "2024/02/02"; // Date = new Date();

  cardColor: string = '#232837';

  curr_read: any = null;

  lowWarning: boolean = false;

  settlement: any = {};
  building: any = {};
  prediction: any = [];
  tanque_children: any = [];

  // options
  legend: boolean = false;
  showLabels: boolean = false;
  animations: boolean = true;
  timeline: boolean = true;

  multi: any = [];
  data: any = [];

  colorScheme: Color = { domain: ['#99CCE5', '#FF7F7F'], group: ScaleType.Ordinal, selectable: true, name: 'Customer Usage', };

  views: any[] = [200, 200];
  
  constructor(
    private store: SettlementsService,
    private summ: SummaryService,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService
  ) {
    let today = new Date().getDate();
    let past = today - 10;
    let pastM = 0;
    let futureM = 2;

    console.log('today => ', today, past);
    if (past <= 0) {
      pastM = 1;
      futureM = 1;
      past = 15;
    }
    console.log('past => ', past, pastM, futureM)
    this.fromDate = new NgbDate(this.a.getFullYear()-1, this.a.getMonth()-pastM, past);
    // new Date(this.a.getFullYear(), this.a.getMonth()+1, 0);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+futureM, 29);
  }
  
    ngOnInit(): void {
      this.loadData();
      this.breadcrumbService.set('@tanque', 'Tanques');     

      // nivel
      let level = this.nivel?.nativeElement;
      this.view = [300,250];
    }

    ngOnChanges(changes: SimpleChange) {
      console.log('changes => ', changes);
    }

    search() {
      this.reloadData();
    }

    updateDate(event: any) {
      this.fromDate = event.from;
      this.toDate = event.to;
    }

    onDateSelection(event: any) {}

    isRange(date: any) {}
    
		isHovered(date: any) {
      return false;
    }
    isInside(date: any) {
      return false;
    }

		hoveredDate: any;

    onSelect(data: any): void {
      console.log('Item clicked', JSON.parse(JSON.stringify(data)));
    }
  
    onActivate(data: any): void {
      console.log('Activate', JSON.parse(JSON.stringify(data)));
    }
  
    onDeactivate(data: any): void {
      console.log('Deactivate', JSON.parse(JSON.stringify(data)));
    }

    async loadData() {
      this.route.params.subscribe(async (params: any) => {
        this.tanqueId = params['id'];

        this.store.getUnitByTanque(this.tanqueId).subscribe((data: any) => {
          console.log('getUnitByTanque data => ', data);
          this.deptos = data;
        });

        this.store.getTanque(this.tanqueId).subscribe((data: any) => {
          console.log('getTanque data => ', data);
          this.tanque = data;
          this.breadcrumbService.set('@consumoTanque', data.name);
          
          this.building = data.building;
          this.store.getSettlement(data.building.settlement_id).subscribe((settlement: any) => {
            this.settlement = settlement;
          });
        });

        this.store.getChildrenTanks(this.tanqueId).subscribe((data: any) => {
          console.log('getChildrenTanks data => ', data);
          this.tanque_children = data;
        });

        this.store.getTanqueEstimation(this.tanqueId, {
          fromDate: `${this.fromDate['year']}-${this.fromDate['month']}-${this.fromDate['day']}`,
          toDate: `${this.toDate['year']}-${this.toDate['month']}-${this.toDate['day']}`
        }).subscribe((data: any) => {
          console.log('getTanqueEstimation data => ', data);
          this.multi = data;
          this.data = data;
          this.readings = data.readings;
          this.refuels = data.refuels;
          this.consumptions = data.consumptions;
          this.prediction = data.prediction;
          this.current_read = [{ value: data.readings[data.readings.length-1].lts_estimated, name: 'Lectura actual' }];
          this.curr_read = data.readings[data.readings.length-1];

          // console.log('refuels => ', this.refuels);
          // console.log('current_read => ', this.current_read);
          
          this.lowWarning = data.readings[data.readings.length-1].lts_estimated < this.tanque.limite_inferior;
        });

        this.store.getTanqueAnova(this.tanqueId, {
          fromDate: `${this.fromDate['year']}-${this.fromDate['month']}-${this.fromDate['day']}`,
          toDate: `${this.toDate['year']}-${this.toDate['month']}-${this.toDate['day']}`
        }).subscribe((data: any) => {
          console.log('ANOVA data => ', data);
          this.anova_asset_readings = JSON.parse(data);
        });
      });

      // this.summ.getTanqueSummary(this.tanqueId).subscribe((data: any) => {
        // console.log('getTanqueSummary data => ', data);
        // this.consumption_data = data; // .consumptions;
        // this.consumption_consumptions = data.consumptions;
        // this.consumption_tanques = data.readings;
      // });

    }

    reloadData() {
      this.store.getTanqueEstimation(this.tanqueId, {
        fromDate: `${this.fromDate['year']}-${this.fromDate['month']}-${this.fromDate['day']}`,
        toDate: `${this.toDate['year']}-${this.toDate['month']}-${this.toDate['day']}`
      }).subscribe((data: any) => {
        console.log('getTanqueEstimation data => ', data);
        this.data = data;
        this.readings = data.readings;
        this.refuels = data.refuels;
        this.consumptions = data.consumptions;
      });

      this.store.getTanqueAnova(this.tanqueId, {
        fromDate: `${this.fromDate['year']}-${this.fromDate['month']}-${this.fromDate['day']}`,
        toDate: `${this.toDate['year']}-${this.toDate['month']}-${this.toDate['day']}`
      }).subscribe((data: any) => {
        // console.log('ANOVA data => ', data);
        this.anova_asset_readings = JSON.parse(data);
        console.log('ANOVA data => ', this.anova_asset_readings);
      });
    }

    reportReadings() {
      this.creatingReport = true;
      let filter: any[] = [];
      this.readings.map((reading: any) => {
        filter.push({
          folio: reading.id,
          carga: reading.value,
          tipo_lectura: reading.read_type == 1 ? 'Lectura' : 'Recarga',
          litros_estimados: reading.lts_estimated,
          fecha: reading.created_at,
        });
      });
      
      let options = {
        title: 'Reporte de lecturas',
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        useBom: true,
        headers: [
          "Folio",
          "Carga",
          "Tipo de lectura",
          "Litros estimados",
          "Fecha"
        ]
      };

      console.log('filter => ', filter);

      new ngxCsv(filter, `reporte_lecturas_tanque-${this.tanque.name}`, options);
      this.creatingReport = false;
    }

    reportRefuels() {}

    reportConsumptions() {
      this.creatingReport = true;
      let filter: any[] = [];
      this.consumptions.map((reading: any) => {
        filter.push({
          folio: reading.bill_id,
          litros: reading.liters,
          fecha: reading.created_at,
        });
      });
      
      let options = {
        title: 'Reporte de consumos',
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        useBom: true,
        headers: [
          "Folio",
          "Litros",
          "Fecha"
        ]
      };

      console.log('filter => ', filter);

      new ngxCsv(filter, `reporte_consumos_tanque-${this.tanque.name}`, options);
      this.creatingReport = false;
    }

    reportChildReadings() {
      this.creatingReport = true;
      let filter: any[] = [];

      this.data.children.map((child: any) => {
        console.log('child ====> ', child);
        child.map((reading: any) => {
          console.log('reading ====> ', reading);
          filter.push({
            nombre: reading.tanque_name,
            lectura: reading.value,
            estimado: reading.lts_estimated,
            fecha: reading.created_at,
          });
        });
      });

      // this.tanque_children.map((reading: any) => {
        // filter.push({
          // nombre: reading.tanque.name,
          // lectura: reading.readings.value,
          // fecha: reading.readings.created_at,
        // });
      // });
      
      let options = {
        title: 'Reporte de lecturas de tanques arreglo',
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        useBom: true,
        headers: [
          "Nombre",
          "Lectura",
          "Estimado",
          "Fecha"
        ]
      };

      console.log('filter => ', filter);

      new ngxCsv(filter, `reporte_lecturas_tanques_arreglo-${this.tanque.name}`, options);
      this.creatingReport = false;
    }

}
